const careQualityInternalMessages = {
  CARE_QUALITY_INTERNAL_PAGE: {
    TITLE: 'Non-Compliant to measure',
    SUB_TITLE: {
      PART1: 'Showing member summary of the selected member group from ',
      PART2: ' to ',
    },
    breadCrumb: {
      text: 'text',
      careNavigation: 'Care Gaps Internal',
    },
    SUMMARY_CARDS: {
      CURRENT_RATE: 'Current Rate',
      PREVIOUS_RATE: 'Previous Rate',
      ELIGIBLE_MEMBERS: 'Eligible Members',
      COMPLIANT: 'Compliant',
      NON_COMPLIANT: 'Non-Compliant',
      TARGET: 'Target',
      NOT_ENOUGH_DATA: 'Not Enough Data',
    },
    SCATTER_PLOT: {
      TITLE: 'Member Distribution',
      SUB_TITLE: 'To see more about the member distribution',
      Y_AXIS: ['Acuity', 'High', 'Medium', 'Low'],
    },
    SERVICE_TYPE: {
      TITLE: 'Service Type Distribution',
      SUB_TITLE: 'To see more about the service type distribution',
      CLICK_HERE: 'Click Here',
      CHART_TITLE: 'Primary Care Distribution',
    },
    PIE_CHART: {
      TITLE: 'Primary Care Distribution',
      SUB_TITLE: 'To see more about Primary Care Distribution',
      CLICK_HERE: 'Click Here',
      CHART_TITLE1: 'Eligible',
      CHART_TITLE2: 'Compliant',
      CHART_TITLE3: 'Non-Compliant',
    },
    MEMBER_TABLE: {
      TITLE: 'Member Details',
      SUB_TITLE: 'To see more about the member details click on a member',
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
    ACUITY_INFO_TEXT: 'Acuity is determined through the HHS HCC categories',
  },
};

export default careQualityInternalMessages;
